// extracted by mini-css-extract-plugin
export var notificationHost = "_ka-0";